

























































import Component from "vue-class-component";
import { mapGetters, mapActions } from 'vuex';
import {Base} from '@/base';

@Component({
  name: 'SidebarComponent'
})
export default class SidebarComponent extends Base{
  // Computed
  get isHidedTabs(): any[] {
    return ['escrow', 'communication'];
  }
  get getUsualNavigation() {
    return this.getSidebarLinks.filter(navigation => !this.isHidedTabs.includes(navigation.name));
  }
  get getSpecialNavigation() {
    return this.getSidebarLinks.filter(navigation => this.isShowTabs(navigation.name));
  }
  // Methods
  isShowTabs(tabName) {
    if (tabName === 'escrow') {
      return this.isUsedEscrow && this.isReader;
    } else if (tabName === 'communication') {
      return this.isReader || this.isOwner();
    }
    return false;
  }
};
